import ButtonTypes from './buttonTypes';

const urgencyStatus = {
  NORMAL: 'Normal',
  URGENT: 'Urgent',
};

export const urgencyStatusInfo = {
  [urgencyStatus.NORMAL]: {
    title: 'Normal',
    state: ButtonTypes.LIGHT
  },
  [urgencyStatus.URGENT]: {
    title: 'Urgent',
    state: ButtonTypes.INFO
  },
};

export const urgencyStatusList = [
  { label: urgencyStatus.NORMAL, value: urgencyStatus.NORMAL },
  { label: urgencyStatus.URGENT, value: urgencyStatus.URGENT },
];
export default urgencyStatus;
